module.exports = __webpack_public_path__ + "02_mid_brown.c6282159.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer5/02_mid_brown.png
// module id = /LmG
// module chunks = 0